import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pad10 rad20 llgreyBg hoverLgreyBg mt20 text-left"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 0,
  class: "pad10"
}
const _hoisted_4 = { class: "fl mr20" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "greenBg pad3 rad4 fs11 fw600" }, "確定済", -1)
const _hoisted_6 = {
  key: 0,
  class: "fs11"
}
const _hoisted_7 = { class: "fl fw600 arial fs20" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "ml10 mt10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.room && _ctx.appo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "fw600",
          textContent: _toDisplayString(`【${_ctx.room.public_id}】${_ctx.room.appeal_content ? _ctx.room.appeal_content.title : _ctx.appo.name}`)
        }, null, 8, _hoisted_2),
        (_ctx.Room.FIXED_STATUSES.includes(_ctx.room.status))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                (_ctx.Util.isPresent(_ctx.appo.selected_mag_dic))
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createTextVNode(" 担当: "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.truncate(_ctx.selectedMagTeamName(), 5)), 1)
                    ])), [
                      [
                        _directive_tooltip,
                        _ctx.selectedMagTeamName(),
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.appo.jp_format), 1),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.room.members, (mem, memindex) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "",
              key: memindex
            }, _toDisplayString(mem.name) + _toDisplayString(mem.company_name ? `（${mem.company_name}）` : ``), 1))
          }), 128))
        ]),
        _hoisted_10
      ]))
    : _createCommentVNode("", true)
}